// eslint-disable-next-line import/no-duplicates
import Swiper from 'swiper';
// eslint-disable-next-line import/no-duplicates

const createSlider = ($slider) => {
  if ($slider.querySelectorAll('.swiper-slide').length <= 2) {
    return;
  }

  new Swiper($slider, {
    slidesPerView: 'auto',
  });
}

export default function initCrossContentTextSlider() {
  const $container = document.querySelector('.cp-cross-content-text');

  if (!$container) {
    return;
  }

  const $slider = $container.querySelector('.js-cross-content-text')
  if (!$slider) {
    return;
  }

  createSlider($slider)
}
